import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {DistrictDTO} from '../../../shared/dto/district.model';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {SidModel} from '../../../shared/dto/sid.model';
import Swal from "sweetalert2";
import {ApprovalService} from '../../../service/approval.service';

@Component({
  selector: 'app-post-list',
  templateUrl: './post-list.component.html',
  styleUrls: ['./post-list.component.scss']
})
export class PostListComponent implements OnInit {
  public dispatchForm: FormGroup;
  public districtList: DistrictDTO[];
  key: string;
  display: any;
  target: SidModel[]=[];
  source: SidModel[]=[];
  list:string[]=[];
  seleted:boolean=false

  constructor(private applicantService:ApplicantRequestService,private approvalService: ApprovalService) { }

  ngOnInit() {
    this.dispatchForm = new FormGroup({
      district: new FormControl(0),
    });

    this.loadDistrict();

  }

  loadDistrict() {
    this.applicantService.getAllDistrict().subscribe(
      (data: DistrictDTO[]) => {
        this.districtList = data;
      }
    );
  }

  loadRequest() {
    this.key = 'id';
    this.display = 'sid';
    this.applicantService.findSidByDistrict(this.dispatchForm.value.district).subscribe(
      (data: SidModel[]) => {
        this.target=data;
      }
    );
  }

  generate() {
    if(this.source.length > 0) {
      this.source.forEach(item => {
        this.list.push(item.id);
      });
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to dispatch sid cards?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.approvalService.dispatchSidGenerateList(this.list);
        } else {
        }
      });
    } else {
      this.seleted=true;
    }


  }

}
